import {
   AddEmailModel,
   EmailResetModel,
   LoginModel,
   MessageSignatureModel,
   PasswordResetRequestModel,
   SignupEmailModel,
   SignupInitialModel,
   SignupModel,
   SignUpWithGoogleModel,
   SignUpWithAppleModel,
} from '../models';
import {
   AddEmailSchema,
   EmailResetSchema,
   EmailVerificationSchema,
   LoginSchema,
   MessageSignatureSchema,
   PasswordResetRequestSchema,
   SignupEmailSchema,
   SignupInitialSchema,
   SignupSchema,
} from '../schemas';
import { validateWithSchema } from '../utils';
import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const authenticate = async (signature: MessageSignatureModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web3/authenticate', validateWithSchema(MessageSignatureSchema, signature))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

// get /web3/auth-transaction
export const getAuthTransaction = async (message: string, signer: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/auth/web3/auth-transaction', {
         params: {
            message,
            signer,
         },
      })
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const getUserAuthToken = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/auth/web3/auth-token')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const refreshAuthToken = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/refresh-token')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const logout = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/logout')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const signup = async (signup: SignupModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup', validateWithSchema(SignupSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const signupEmail = async (signup: SignupEmailModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup', validateWithSchema(SignupEmailSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const signupCheck = async (signup: SignupInitialModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup-check-info', validateWithSchema(SignupInitialSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const signupEmailCheck = async (signup: SignupEmailModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup-check-info', validateWithSchema(SignupSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const addEmailCheck = async (signup: AddEmailModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/signup-check-info', validateWithSchema(AddEmailSchema, signup))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const requestEmailVerification = async (email: string, newWallet?: string): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/emails/request-verification', validateWithSchema(EmailVerificationSchema, { email, newWallet }))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const login = async (login: LoginModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/authenticate', validateWithSchema(LoginSchema, login))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const linkWeb3Wallet = async (signature: MessageSignatureModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/link-wallet', validateWithSchema(MessageSignatureSchema, signature))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const resetPasswordRequestLink = async (email: string): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/password/request-reset', validateWithSchema(EmailVerificationSchema, { email }))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const resetPassword = async (passwordReset: PasswordResetRequestModel): Promise<RequestResponse> => {
   return await axiosSecure
      .post('/auth/web2/password/reset', validateWithSchema(PasswordResetRequestSchema, passwordReset))
      .then((response) => handleResponse(response))
      .catch(handleError);
};

// export const resetEmail = async (emailReset: EmailResetModel): Promise<RequestResponse> => {
//    return await axiosSecure
//       .post('/auth/web2/email/reset', validateWithSchema(EmailResetSchema, emailReset))
//       .then((response) => handleResponse(response))
//       .catch(handleError);
// };

// export const resetEmailCheck = async (emailReset: EmailResetModel): Promise<RequestResponse> => {
//    return await axiosSecure
//       .post('/auth/web2/email/reset-check-info', validateWithSchema(EmailResetSchema, emailReset))
//       .then((response) => handleResponse(response))
//       .catch(handleError);
// };

export async function loginWithGoogle(data: SignUpWithGoogleModel): Promise<RequestResponse> {
   return await axiosSecure
      .post(`/auth/web2/authenticate/google`, data)
      .then(handleResponse)
      .catch(handleError);
}

export async function loginWithApple(data: SignUpWithAppleModel): Promise<RequestResponse> {
   return await axiosSecure
      .post(`/auth/web2/authenticate/apple`, data)
      .then(handleResponse)
      .catch(handleError);
}

export async function linkGoogleAccount(data: SignUpWithGoogleModel): Promise<RequestResponse> {
   return await axiosSecure
      .post(`/auth/web2/link-google`, data)
      .then(handleResponse)
      .catch(handleError);
}

export async function unlinkGoogleAccount(): Promise<RequestResponse> {
   return await axiosSecure
      .post(`/auth/web2/unlink-google`)
      .then(handleResponse)
      .catch(handleError);
}

export async function linkAppleAccount(data: SignUpWithAppleModel): Promise<RequestResponse> {
   return await axiosSecure
      .post(`/auth/web2/link-apple`, data)
      .then(handleResponse)
      .catch(handleError);
}

export async function unlinkAppleAccount(): Promise<RequestResponse> {
   return await axiosSecure
      .post(`/auth/web2/unlink-apple`)
      .then(handleResponse)
      .catch(handleError);
}
